// extracted by mini-css-extract-plugin
export default {"about":"Contact_about__JNsnz","cont":"Contact_cont__358T+","text":"Contact_text__tfAWa","img":"Contact_img__INXGx","msg":"Contact_msg__r0ZQH"};